<template>
  <div v-if="loading" class="loading">Aguarde ...</div>
  <div v-else class="container-fluid">
    <div class="col-sm-12 text-left">
      <h3>
        <router-link to="/clientes/cob">Cobrança</router-link> » Docs
      </h3>
      <small>{{clientes.length}} resultado(s) encontrados</small>
      <small v-if="this.$route.query.s"> que contém '{{this.$route.query.s}}'</small>
    </div>
    <table>  
      <tr>
        <td></td>
        <td></td>
        <td class="lt500">cnpj</td>
        <td>razao</td>
        <td class="text-center">NFS-e</td>
        <td class="text-center">BOLETO</td>
        <td>dia</td>
        <td>valor</td>
        <td>contato</td>
      </tr>
      <tr v-for="cliente,index in clientes">
        <td><a @click.prevent="select4edit(cliente.cod)" class="glyphicon glyphicon-pencil" title="Editar"></a></td>
        <td><a @click.prevent="select4agenda(cliente.cod)" class="glyphicon glyphicon-book" title="Agenda"></a></td>
        <td class="lt500">{{maskCnpj(cliente.cnpj)}}</td>
        <td>{{cliente.razao}}<br><small>{{cliente.fantasia}}</small></td>
        <td class="text-center">
          <a v-if="cliente.emailnfse" :href="nfseMailLink(cliente.email)">
            <i class="glyphicon glyphicon-envelope" @click="verify($event)"></i>
          </a>
        </td>
        <td class="text-center">
          <a v-if="cliente.emailboleto" :href="boletoMailLink(cliente.email)">
            <i class="glyphicon glyphicon-envelope" @click="verify($event)"></i>
          </a>
        </td>
        <td>{{cliente.cobdia}}</td>
        <td>{{maskMonetario(cliente.cobvalor, true)}}</td>
        <td>
            <span v-for="telefone in cliente.telefone" class="nowrap">{{maskTelefone(telefone.numero)}}</br></span>
        </td>
      </tr>
    </table>
    <br><br><br>
  </div>
</template>

<script>
  import Mask from './Mask.js'
  export default {
    name: 'datalist',
    data () {
      return {
        mesAno: '',
        loading: false,
        clientes: []
      }
    },
    methods: {
      load (params = '') {
        const url = './api/php/getcliente.php'
        this.$http.post(url, JSON.stringify(params)).then(
          function (response) {
            console.log(response.body)
            if (response.body.length > 0) {
              this.clientes = response.body
            } else {
              this.clientes = []
            }
          },
          function (error) {
            console.log(error)
          }
        )
      },
      select4edit (cod) {
        this.$router.push({path: `/cliente/${cod}`})
      },
      select4agenda (cod) {
        this.$router.push({path: `/agenda/c/${cod}`})
      },
      nfseMailLink (emails) {
        let email = this.filterMail(emails, 'nfse')
        if (email) {
          return `mailto:${email}?Subject=NFS-e%20PWS%20Informatica%20-%20Emitida%20em%20${this.mesAno}`
        } else {
          return ''
        }
      },
      boletoMailLink (emails) {
        let email = this.filterMail(emails, 'boleto')
        if (email) {
          return `mailto:${email}?Subject=Boleto%20PWS%20Informatica%20-%20Ref.%20${this.mesAno}`
        } else {
          return ''
        }
      },
      filterMail (emails, keyword) {
        let email = emails.filter((email) => email.descricao === keyword)
        if (email.length) {
          email = email[0]
          console.log(email.endereco)
          return email.endereco
        } else {
          return false
        }
      },
      verify (event) {
        event.target.className += ' text-muted'
      }
    },
    created: function () {
      this.maskCnpj = Mask.cnpj
      this.maskMonetario = Mask.monetario
      this.maskTelefone = Mask.telefone
      const keyword = this.$route.query.s
      this.load({'docs': true, 'keyword': keyword})
      const data = new Date()
      if (data.getDate() < 20) {
        this.mesAno = (data.getMonth() + 1) + '/' + data.getFullYear()
      } else {
        if (data.getMonth() === 11) {
          this.mesAno = '01/' + (data.getFullYear() + 1)
        } else {
          this.mesAno = (data.getMonth() + 2) + '/' + data.getFullYear()
        }
      }
    },
    watch: {
      '$route' (to, from) {
        const keyword = this.$route.query.s
        this.load({'docs': true, 'keyword': keyword})
      }
    }
  }
</script>

<style scoped>
    .container-fluid {
      width: 80vw;
      margin: auto;
    }
    table {
      font: 12px sans-serif;
      color: #333;
      border-collapse: collapse;
      outline: 2px solid #333;
      text-align: left;
      width: 80vw;
    }
    table tr {
      background: #fcfcfc;
    }
    table tr:nth-child(2n+1) {
      background: #f1f1f1;
    }
    table tr:hover{
      background: #ccc;
    }
    table tr:first-child {
      background: #333;
      color: #fff;
      text-transform: uppercase;
    }
    table tr td {
      padding: 5px;
    }
    table tr td small {
      color: #777;
    }
    a.glyphicon {
      text-decoration: none
    }
    .glyphicon-envelope {
      font-size: 20px;
    }
    .nowrap {
      white-space: nowrap;
    }
    @media (max-width: 499px) {
      .container-fluid {
        width: 100vw;
        margin: 0;
        padding: 0;
      }
      table {
        font: 10px sans-serif;
        width: 100vw;
      }
      .lt500 {
        display: none;
      }
      .glyphicon-envelope {
        font-size: 12px;
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/CliRelCobDocs.vue